import React from 'react';
import { Dialog } from '@medely/web-components';

interface Props {
  visible: boolean;
  onClose: () => void;
  videoUrl: string;
  isFromApp?: boolean;
}

function getQueryParam(key: string): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return new URLSearchParams(window.location.search).get(key);
}

/**
 * Return the modal width so that:
 *  - It never exceeds defaultWidth
 *  - On small screens, it leaves `sideGutter * 2` px total margin
 */
function clampModalWidth(screenW: number, defaultWidth: number, sideGutter: number): number {
  const maxAvailable = screenW - sideGutter * 2;
  return screenW && maxAvailable < defaultWidth ? maxAvailable : defaultWidth;
}

export const OnboardingVideoModal: React.FC<Props> = ({
  visible,
  onClose,
  videoUrl,
  isFromApp: propIsFromApp,
}) => {
  if (!visible) {
    return null;
  }

  const isFromApp = propIsFromApp ?? getQueryParam('fromApp') === '1';

  // parse reported screen width
  const rawW = parseInt(getQueryParam('screenW') || '', 10);
  const screenW = Number.isNaN(rawW) ? 0 : rawW;

  // defaults
  const defaultWidth = isFromApp ? 311 : 640;
  const defaultHeight = isFromApp ? 245 : 360;
  const sideGutter = 16;

  const widthPx = clampModalWidth(screenW, defaultWidth, sideGutter);

  const paperStyle: React.CSSProperties = {
    width: widthPx,
    height: defaultHeight,
    margin: '0 auto',
    borderRadius: 16,
    overflow: 'hidden',
    position: 'relative',
  };

  const HEADER_HEIGHT = 56;

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      PaperProps={{ style: paperStyle }}
      title="Onboarding walkthrough"
      data-testid="onboarding-video-dialog"
    >
      <iframe
        src={videoUrl}
        sandbox="allow-scripts allow-same-origin allow-presentation"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="Onboarding video"
        style={{
          position: 'absolute',
          top: HEADER_HEIGHT,
          left: 0,
          width: '100%',
          height: `calc(100% - ${HEADER_HEIGHT}px)`,
          border: 'none',
        }}
      />
    </Dialog>
  );
};
